<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12">
        <v-sheet class="elevation-1">
          <v-card flat :loading="loading">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="9">
                  <v-text-field 
                    v-model="search.keyword"
                    hide-details="auto" 
                    label="Từ khóa..." 
                    placeholder="Từ khóa..."
                    autocomplete="off"
                    outlined
                    dense
                    flat
                    solo
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn 
                    block 
                    color="primary"
                    @click="searchProduct"
                    class="py-5"
                  >
                    <v-icon>mdi-magnify</v-icon>
                    Tìm kiếm
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="showf">
                <v-col
                  cols="12"
                  sm="auto"
                >
                  <v-select
                    v-model="search.type"
                    :items="types"
                    item-text="ten_loai"
                    item-value="id"
                    label="Loại hàng hóa"
                    multiple
                    dense
                    hide-details
                    outlined
                    flat
                    solo
                    clearable
                  />
                </v-col>
                <v-col 
                  cols="12" 
                  md="2"
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        dark
                        color="blue-grey"
                        class="py-5"
                        block
                      >
                        <v-icon>
                          mdi-sort
                        </v-icon>
                        <v-icon>
                          mdi-menu-down
                        </v-icon>
                        <v-icon
                          v-if="selectedOrderItem"
                          @click.stop="selectedOrderItem=null"
                        >
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item-group
                        v-model="selectedOrderItem"
                        color="primary"
                      >
                        <template v-for="(order, index) in orders">
                          <v-list-item
                            :key="index" 
                            :value="order.value"
                          >
                            <v-list-item-title>
                              <v-icon>
                                {{order.action}}
                              </v-icon>
                              {{order.text}}
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  align="center"
                  justify="center"
                  class="pa-0"
                >
                  <v-icon 
                    color="primary"
                    medium
                    @click="showFilter"
                  >mdi-chevron-{{!showf ? 'down' : 'up'}}</v-icon>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>
    <h5 class="text-center py-2 font-weight-light">
      Trang {{currentPage}} (Tổng {{totalPages}} Trang, {{totalItems}} mặt hàng)
    </h5>
    <v-row>
      <v-col 
        v-for="(product, index) in items" 
        :key="index" 
        cols="12"
        sm="6"
        md="3"
        lg="2"
      >
        <v-sheet>
          <v-hover
            v-slot="{ hover }"
          >
            <v-card flat>
              <router-link
                :to="{ name: 'ProductTraceView', params: { id: product.id }}"
              >
                <v-img
                  height="200"
                  :src="`${apiBaseUrl}/uploads/${product.anh_dai_dien}`"
                  :style="{opacity: hover ? '0.3' : 1}"
                  :class="hover ? 'zoom' : ''"
                />
              </router-link>
              <v-card-title>
                <router-link
                  :to="{ name: 'ProductTraceView', params: { id: product.id }}"
                  class="black--text text-body-2 font-weight-bold"
                >
                  {{product.ten_sp}}
                </router-link>
              </v-card-title>
              <v-card-subtitle>Giá bán: 
                <span v-if="product.gia_ban > 0">{{product.gia_ban | currency('đ')}}</span>
                <span v-else>Liên hệ</span>
              </v-card-subtitle>
              <v-card-actions>
                <v-list-item class="grow">
                  <v-list-item-avatar tile>
                    <div 
                      v-if="product.ma_truy_xuat"
                      @click.stop="zoomQrCode(product)" 
                    >
                      <qrcode-vue 
                        :value="GenerateURL(product)" 
                        :size="32" 
                        level="H"
                        style="cursor: pointer;"
                      />
                    </div>
                  </v-list-item-avatar>
                  <v-row
                    align="center"
                    justify="end"
                  >
                    <v-btn 
                      text 
                      color="primary"
                      :to="{ name: 'ProductTraceView', params: { id: product.id }}"
                    >
                      Xem chi tiết
                    </v-btn>
                  </v-row>
                </v-list-item>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogQrZoom"
      persistent
      max-width="290"
    >
      <v-card>
        <v-app-bar
          dark
          color="primary"
        >
          <v-icon>
            mdi-qrcode-scan
          </v-icon>
          <v-spacer/>
          <v-toolbar-title>Mã truy xuất</v-toolbar-title>
          <v-spacer/>
          <v-btn
            icon
            @click="closeZoomQrCode()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                v-if="qrItem"
                align="center"
                justify="center"
              >
                <qrcode-vue 
                  :value="GenerateURL(qrItem)" 
                  :size="170" 
                  level="H"
                />
                {{qrItem ? qrItem.ma_truy_xuat: null}}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import QrcodeVue from 'qrcode.vue';
  import { mapGetters, mapState } from 'vuex';
  export default {
    components: {
      QrcodeVue
    },
    data: () => ({
      search: {
        keyword: '',
        type: ''
      },
      loading: false,
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      items: [],
      types: [],
      dialogQrZoom: false,
      qrItem: null,
      showf: false,
      selectedOrderItem: null,
      orders:[
        {
          action: 'mdi-order-alphabetical-ascending', 
          value: 'tieu_de', 
          text: 'Tên hàng hóa'
        },
        {
          action: 'mdi-order-numeric-ascending', 
          value: 'gia_ban', 
          text: 'Giá bán'
        },
        {
          action: 'mdi-order-numeric-ascending', 
          value: 'created_at', 
          text: 'Ngày đăng'
        }
      ]
    }),
    mounted () {
      this.initialize();
      this.getTypes();
    },
    computed: {
      ...mapState([ 
        'config'
      ]),
      ...mapGetters([
        'isLogged'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    methods: {
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if(this.search)
        {
          if(this.search.type){
            params["type"] = this.search.type;
          }
          if(this.search.keyword){
            params["keyword"] = this.search.keyword;
          }
          if(this.selectedOrderItem){
            params["order"] = this.selectedOrderItem;
          }
        }
        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
        this.$vuetify.goTo(0);
      },
      initialize () {
        const params = this.getRequestParams(
          this.currentPage,
        );
        this.loading = true;
        let request = {
          params: params
        };
        axios.get("api/v1/public/products", request)
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            this.totalPages = Math.ceil(caluTotalPage);
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      GenerateURL(item){
        let path = this.$router.resolve({
          name: 'ProductTraceView', 
          params: {
            id: item.id
          }
        });
        return `${window.location.origin}${path.href}`;
      },
      searchProduct(){
        this.initialize();
      },
      getTypes () {
        axios.get("api/v1/public/product-types")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      zoomQrCode(item){
        this.dialogQrZoom=true;
        this.qrItem=item;
      },
      closeZoomQrCode(){
        this.dialogQrZoom=false;
      },
      showFilter(){
        this.showf = !this.showf;
      },
      addToCart(item) {
        if(this.isLogged){
          this.$store.commit('addToCart', item);
        }
        this.$router.push({ name: 'Cart' });
      }
    }
  }
</script>
<style>
  .qrcode{
    border: 1px solid #79ce09;
    padding: 5px;
    cursor: zoom-in;
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .v-card__actions.productInfo{
    text-overflow: ellipsis;
    height: 56px;
  }
  .v-image .v-image__image {
    transition: all 0.2s;
  }
  .v-image.zoom .v-image__image {
    transform: scale(1.2);
  }
  .v-card__text, .v-card__title {
    word-break: normal;
  }
</style>
